export const PRIVACY_POLICY_HREF = 'https://www.fooda.com/privacy-policy';
export const TERMS_OF_USE_HREF = 'https://www.fooda.com/terms-of-use';
export const SUPPORT_PORTAL_HREF =
  'https://foodacustomerhelp.atlassian.net/servicedesk/customer/portal/3';
export const SUPPORT_PORTAL_AVAILABILITY_HREF =
  'https://foodacustomerhelp.atlassian.net/servicedesk/customer/portal/3/group/25/create/150';
